export const IMPRESSION_GROUP = '';
export const PAGE_NAME = 'seller_page';
